import type { Command } from "../types.ts";

export const clear: Command = {
  name: "clear",
  aliases: ["cls"],
  description: "Clear the screen.",
  run(ctx) {
    ctx.clear();
  },
};

export const banner: Command = {
  name: "banner",
  description: "Print the masthead.",
  run(ctx) {
    printBanner(ctx.printHTML, ctx.term.profile.name, ctx.term.profile.role);
  },
};

export const echo: Command = {
  name: "echo",
  description: "Echo text back.",
  usage: "/echo <text>",
  run(ctx) {
    ctx.print(ctx.args.join(" "));
  },
};

export const whoami: Command = {
  name: "whoami",
  description: "Print the current user.",
  run(ctx) {
    ctx.print(ctx.term.profile.handle);
  },
};

export const date: Command = {
  name: "date",
  description: "Show the current date and time.",
  run(ctx) {
    ctx.print(new Date().toString());
  },
};

/** The masthead — a typographic lockup, not ASCII art. Figlet banners are
    fixed-width by definition, so they can't reflow and break on any screen
    narrower than the art. Shared with the boot sequence in main.ts. */
export function printBanner(
  printHTML: (h: string) => void,
  name: string,
  role = "",
): void {
  printHTML(
    `<div class="masthead">` +
      `<span class="masthead-name">${esc(name)}</span>` +
      (role ? `<span class="masthead-role">${esc(role)}</span>` : "") +
      `</div>`,
  );
  printHTML(`<div class="masthead-rule"></div>`);
}

function esc(s: string): string {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
